import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from "primeng/components/common/messageservice";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
import {ActivatedRoute, Router} from '@angular/router';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import * as html2pdf from "html2pdf.js"


@Component({
  selector: 'addSubjectsS',
  templateUrl: 'view-generated-paper.component.html',
  styleUrls: ['view-generated-paper.component.scss'],

})
export class ViewGeneratedPaperComponent implements OnInit {



  public schoolId: any;

  public userId :string;
  public BranchId :string;

  public paper :string;
  public paperName :string;

  public PDFfile: any;

  public pdfUrl: SafeResourceUrl;


  public questionsList: any = [];
  public mcqQuestions: any = [];
  public contextQuestions: any = [];


  loading = "none";
  public searchHistory: any;


  constructor(private dataAnalyticsService: DataAnalyticsService,
              private messageService: MessageService,
              private noticeboardService: NoticeboardService,
              private confirmationService: ConfirmationService,
              private localStorage: LocalStorageService,
              private route: ActivatedRoute,
              private router: Router,
              private sanitizer: DomSanitizer,

  ) {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    this.userId = this.localStorage.retrieve('id');
    this.BranchId = this.localStorage.retrieve('branchid');
    const historyString = this.route.snapshot.queryParamMap.get('history');
    this.searchHistory = JSON.parse(decodeURIComponent(historyString));

  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const serializedPaper = params['paper'];
      if (serializedPaper) {
        try {
          const decodedPaper = decodeURIComponent(serializedPaper);
          const paperObj = JSON.parse(decodedPaper);
          // Now you can use paperObj as your object
          console.log(paperObj);

          this.questionsList = JSON.parse(paperObj.Content);
          this.contextQuestions = this.questionsList.contextQuestions;
          this.mcqQuestions = this.questionsList.mcqQuestions;
          //
          this.paperName = paperObj.PaperName;
          console.log(this.contextQuestions);
          console.log(this.mcqQuestions);


        } catch (e) {
          console.error('Error parsing the passed data:', e);
        }
      }
    });
  }


  PrintPdf() {
    const options = {
      filename: this.paperName,
      margin: [15, 0, 15, 0],
      image: { type: 'jpeg', quality: 1 },
      // html2canvas : {},
      layout: 'noBorders',
      html2canvas: {
        dpi: 192,
        scale: 4,
        letterRendering: true,
        useCORS: true,
        // allowTaint : true
      },
      jsPDF: { orientation: 'portrait', unit: 'pt', format: 'a4', compressPDF: false }
    };

    const content: Element = document.getElementById('asdf')

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }



  goBack() {
    const serializedHistory = encodeURIComponent(JSON.stringify(this.searchHistory));
    this.router.navigate(['parent/generated-papers'],{
      queryParams:{
        history: serializedHistory
      }
    });
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/view-generated-paper/view-generated-paper.component.ts